import { useId, useState } from 'react';
import { Popover } from '@mui/material';

const CustomPopover = ({ popoverContent, children }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const id = useId();

  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <>
      <span
        aria-owns={open ? `mouse-over-popover-${id}` : undefined}
        aria-haspopup="true"
        onMouseEnter={handlePopoverOpen}
        onMouseLeave={handlePopoverClose}
      >
        {children}
      </span>
      <Popover
        id={`mouse-over-popover-${id}`}
        sx={{ pointerEvents: 'none' }}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        onClose={handlePopoverClose}
        disableRestoreFocus
      >
        <div className="diff-popover-container">{popoverContent}</div>
      </Popover>
    </>
  );
};

export default CustomPopover;
